// Shared staff-color system for the calendar.
// Each staff member gets a distinct color; events show their owner's color.
// Events assigned to ALL staff show orange. Events with no staff show neutral gray.

// Distinct, high-contrast palette (Tailwind-600 family). Orange is intentionally
// excluded because it is reserved for "assigned to all staff".
export const STAFF_PALETTE = [
  "#2563EB", // blue
  "#16A34A", // green
  "#9333EA", // purple
  "#DB2777", // pink
  "#0891B2", // cyan
  "#CA8A04", // yellow
  "#DC2626", // red
  "#0D9488", // teal
  "#4F46E5", // indigo
  "#65A30D", // lime
  "#E11D48", // rose
  "#7C3AED", // violet
  "#0EA5E9", // sky
  "#059669", // emerald
];

export const ALL_STAFF_COLOR = "#EA580C"; // orange — reserved for "all staff"
export const NEUTRAL_COLOR = "#94A3B8"; // slate-400 — events with no staff owner
export const BIRTHDAY_COLOR = "#EC4899"; // pink-500 — auto-generated birthdays

// Deterministic fallback color from an id, so a staff member without an explicit
// color still renders a stable color.
const hashIndex = (str, mod) => {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % mod;
};

export const colorForStaff = (staff) => {
  if (!staff) return NEUTRAL_COLOR;
  if (staff.color) return staff.color;
  return STAFF_PALETTE[hashIndex(staff.id || staff.name || "", STAFF_PALETTE.length)];
};

// Resolve the display color for a calendar event.
// - all active staff assigned -> orange
// - otherwise the owner's (creator's) color
// - fallback to first assignee, then birthday/neutral
export const colorForEvent = (event, staffById, activeStaffIds) => {
  if (event.is_birthday) return BIRTHDAY_COLOR;
  const assignees = event.notify_staff || [];
  if (
    activeStaffIds && activeStaffIds.length > 0 &&
    assignees.length > 0 &&
    activeStaffIds.every((id) => assignees.includes(id))
  ) {
    return ALL_STAFF_COLOR;
  }
  const owner = event.created_by && staffById[event.created_by];
  if (owner) return colorForStaff(owner);
  if (assignees.length && staffById[assignees[0]]) return colorForStaff(staffById[assignees[0]]);
  return NEUTRAL_COLOR;
};

// The staff whose dots should show on an event (its assignees), for the agenda view.
export const assigneesForEvent = (event, staffById) =>
  (event.notify_staff || []).map((id) => staffById[id]).filter(Boolean);
